"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RsvpStatus = void 0;
var RsvpStatus = /*#__PURE__*/function (RsvpStatus) {
  RsvpStatus["Attending"] = "attending";
  RsvpStatus["NotAttending"] = "not-attending";
  return RsvpStatus;
}({});
exports.RsvpStatus = RsvpStatus;